import { wei } from '@kwenta/wei';
export const ZERO_WEI = wei(0);
export const UNIT_BIG_INT = BigInt(10) ** BigInt(18);
export const ZERO_BIG_INT = BigInt(0);
export const DEFAULT_CRYPTO_DECIMALS = 4;
export const DEFAULT_FIAT_DECIMALS = 2;
export const DEFAULT_NUMBER_DECIMALS = 2;
//# sourceMappingURL=number.js.map